const slideLoaded = (main) => {
    const observer = new MutationObserver((mutationList) => {
        mutationList.forEach((mutation) => {
            if (mutation.type === 'childList') {
                const swiperMain = main.querySelector('article');
                swiperMain.classList.add('swiper');
                main.querySelector('.dd-product-recommendations-wrapper').classList.add('swiper-wrapper');
                main.querySelectorAll('.dd-product-recommendation-template').forEach((elm) => {
                    elm.classList.add('swiper-slide');
                });
                const swiper = new Swiper(swiperMain, {
                    loop: false,
                    slidesPerView: 2.3,
                    spaceBetween: 7,
                    scroll: 'smooth',
                    watchOverflow: true,
                    freeMode: true,
                    breakpoints: {
                        // when window width is >= 640px
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                        },
                        992: {
                            slidesPerView: 5,
                            spaceBetween: 10,
                        },
                    },
                });
            }
        });
    });
    observer.observe(main, {
        childList: true,
    });
};
